import { render, staticRenderFns } from "./ventureData.vue?vue&type=template&id=356d82f6"
import script from "./ventureData.vue?vue&type=script&lang=js"
export * from "./ventureData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports